const chapter = {
  id: 'mathematical-induction',
  slug: 'mathematical-induction',
  subject: 'mathematics',
  subjectLabel: 'Mathematics',
  exam: 'JEE',
  title: {
    english: 'Principle of Mathematical Induction',
        hindi: 'गणितीय आगमन का सिद्धान्त',
  },
  estReadMinutes: 25,
  difficulty: {
    english: 'Easy',
        hindi: 'आसान',
  },
  weightage: {
    english: 'Tool chapter; PYQ rare but used everywhere',
        hindi: 'टूल अध्याय; PYQ दुर्लभ है लेकिन हर जगह उपयोग किया जाता है',
  },
  syllabusTags: ['Algebra', 'Class-11', 'JEE Main'],
  sections: [
    {
      id: 'principle',
      title: {
        english: 'The Principle (PMI)',
        hindi: 'सिद्धान्त (PMI)',
      },
      blocks: [
        {
          type: 'definition',
          title: {
            english: 'PMI (Strong / Weak)',
        hindi: 'पीएमआई (मजबूत/कमजोर)',
          },
          body: {
            english: 'Let $P(n)$ be a statement involving $n \\in \\mathbb{N}$. If (i) $P(1)$ is true and (ii) $P(k) \\Rightarrow P(k+1)$ for every $k \\ge 1$, then $P(n)$ is true for **all** $n \\ge 1$.',
        hindi: 'मान लीजिए $P(n)$ एक कथन है जिसमें $n \\in \\mathbb{N}$ शामिल है। यदि (i) $P(1)$ सत्य है और (ii) $P(k) \\Rightarrow P(k+1)$ प्रत्येक $k \\ge 1$ के लिए है, तो $P(n)$ **सभी** $n \\ge 1$ के लिए सत्य है।',
          },
        },
        {
          type: 'list',
          items: [
            {
              english: '**Step 1 (Base):** verify $P(n_0)$ for the starting value.',
        hindi: '**चरण 1 (आधार):** आरंभिक मान के लिए $P(n_0)$ सत्यापित करें।',
            },
            {
              english: '**Step 2 (Inductive hypothesis):** assume $P(k)$ true.',
        hindi: '**चरण 2 (आगमनात्मक परिकल्पना):** मान लें कि $P(k)$ सत्य है।',
            },
            {
              english: '**Step 3 (Inductive step):** prove $P(k+1)$ using $P(k)$.',
        hindi: '**चरण 3 (आगमनात्मक चरण):** $P(k)$ का उपयोग करके $P(k+1)$ सिद्ध करें।',
            },
            {
              english: 'Conclusion: by PMI, $P(n)$ holds for all $n \\ge n_0$.',
        hindi: 'निष्कर्ष: PMI द्वारा, $P(n)$ सभी $n \\ge n_0$ के लिए मान्य है।',
            },
          ],
        },
        {
          type: 'note',
          body: {
            english: '**Strong induction:** assume $P(1), P(2), \\ldots, P(k)$ to prove $P(k+1)$. Useful when several previous cases are needed (e.g. Fibonacci, recurrences).',
        hindi: '**मजबूत प्रेरण:** $P(k+1)$ को सिद्ध करने के लिए $P(1), P(2), \\ldots, P(k)$ मान लें। उपयोगी जब कई पिछले मामलों की आवश्यकता होती है (उदाहरण के लिए फाइबोनैचि, पुनरावृत्ति)।',
          },
        },
      ],
    },
    {
      id: 'examples',
      title: {
        english: 'Worked Examples',
        hindi: 'हल किये गये उदाहरण',
      },
      blocks: [
        {
          type: 'example',
          problem: {
            english: 'Prove $1 + 2 + 3 + \\cdots + n = \\dfrac{n(n+1)}{2}$.',
        hindi: '$1 + 2 + 3 + \\cdots + n = \\dfrac{n(n+1)}{2}$ सिद्ध करें।',
          },
          solution: {
            english: '**Base:** $n=1$: LHS $= 1$, RHS $= 1$. ✓  **Step:** assume $S_k = k(k+1)/2$. Then $S_{k+1} = S_k + (k+1) = k(k+1)/2 + (k+1) = (k+1)(k+2)/2$. ✓ Hence true for all $n$.',
        hindi: '**आधार:** $n=1$: LHS $= 1$, RHS $= 1$. ✓ **चरण:** मान लें कि $S_k = k(k+1)/2$। फिर $S_{k+1} = S_k + (k+1) = k(k+1)/2 + (k+1) = (k+1)(k+2)/2$. ✓ इसलिए सभी $n$ के लिए सत्य है।',
          },
        },
        {
          type: 'example',
          problem: {
            english: 'Prove $n^3 - n$ is divisible by 6 for all $n \\in \\mathbb{N}$.',
        hindi: 'सिद्ध कीजिए कि $n^3 - n$, सभी $n \\in \\mathbb{N}$ के लिए 6 से विभाज्य है।',
          },
          solution: {
            english: '**Base:** $n=1$: $0$ ✓. **Step:** assume $6 \\mid k^3 - k$. $(k+1)^3 - (k+1) = k^3 + 3k^2 + 3k + 1 - k - 1 = (k^3 - k) + 3k(k+1)$. First term div by 6; $3k(k+1)$ div by 6 (since $k(k+1)$ is even). ✓',
        hindi: '**आधार:** $n=1$ पर $1^3-1=0$, जो 6 से विभाज्य है। **चरण:** मान लें $6 \\mid (k^3-k)$। तब $(k+1)^3-(k+1)=(k^3-k)+3k(k+1)$। पहला पद 6 से विभाज्य है, और $k(k+1)$ सम होने से $3k(k+1)$ भी 6 से विभाज्य है। अतः $6 \\mid \\{(k+1)^3-(k+1)\\}$। इसलिए कथन सभी प्राकृतिक संख्याओं के लिए सत्य है।',
          },
        },
        {
          type: 'example',
          problem: {
            english: 'Prove $2^n > n$ for all $n \\ge 1$.',
        hindi: 'सभी $n \\ge 1$ के लिए $2^n > n$ सिद्ध करें। **आधार:** $2^n > n$ ✓. **चरण:** यदि $n \\ge 1$, तो ( के लिए)। ✓',
          },
          solution: {
            english: '**Base:** $2^1 = 2 > 1$ ✓. **Step:** if $2^k > k$, then $2^{k+1} = 2 \\cdot 2^k > 2k \\ge k + 1$ (for $k \\ge 1$). ✓',
        hindi: '**आधार:** $2^1 = 2 > 1$ ✓. **चरण:** यदि $2^k > k$, तो $2^{k+1} = 2 \\cdot 2^k > 2k \\ge k + 1$ ($k \\ge 1$ के लिए)। ✓',
          },
        },
        {
          type: 'example',
          problem: {
            english: 'Prove $\\sum_{i=1}^n i^2 = \\dfrac{n(n+1)(2n+1)}{6}$.',
        hindi: '$\\sum_{i=1}^n i^2 = \\dfrac{n(n+1)(2n+1)}{6}$ सिद्ध करें।',
          },
          solution: {
            english: 'Base $n=1$: LHS $=1$, RHS $=1$. Inductive step: add $(k+1)^2$ to RHS$_k$ and simplify to RHS$_{k+1}$. Algebra: $\\frac{k(k+1)(2k+1)}{6} + (k+1)^2 = \\frac{(k+1)(2k^2+k+6k+6)}{6} = \\frac{(k+1)(k+2)(2k+3)}{6}$. ✓',
        hindi: 'आधार $n=1$: LHS $=1$, RHS $=1$. आगमनात्मक चरण: $(k+1)^2$ को RHS$_k$ में जोड़ें और RHS$_{k+1}$ को सरल बनाएं। बीजगणित: $\\frac{k(k+1)(2k+1)}{6} + (k+1)^2 = \\frac{(k+1)(2k^2+k+6k+6)}{6} = \\frac{(k+1)(k+2)(2k+3)}{6}$. ✓',
          },
        },
      ],
    },
    {
      id: 'pitfalls',
      title: {
        english: 'Common Pitfalls',
        hindi: 'सामान्य त्रुटियाँ',
      },
      blocks: [
        {
          type: 'warning',
          body: {
            english: 'Forgetting the **base case** invalidates the proof — even if inductive step holds.',
        hindi: '**बेस केस** को भूलने से प्रमाण अमान्य हो जाता है - भले ही आगमनात्मक चरण मान्य हो।',
          },
        },
        {
          type: 'list',
          items: [
            {
              english: 'Use the inductive hypothesis explicitly — write down what you are assuming.',
        hindi: 'आगमनात्मक परिकल्पना का स्पष्ट रूप से उपयोग करें - आप जो मान रहे हैं उसे लिखें।',
            },
            {
              english: 'For inequalities, double-check the inductive step is sharp enough (sometimes $k \\ge 2$ or $k \\ge 4$ is needed).',
        hindi: 'असमानताओं के लिए, दोबारा जांचें कि आगमनात्मक चरण पर्याप्त तीव्र है (कभी-कभी $k \\ge 2$ या $k \\ge 4$ की आवश्यकता होती है)।',
            },
            {
              english: 'For divisibility, look for ways to add/subtract a multiple to expose the assumed expression.',
        hindi: 'विभाज्यता के लिए, कल्पित अभिव्यक्ति को उजागर करने के लिए add/subtract गुणज के तरीकों की तलाश करें।',
            },
          ],
        },
      ],
    },
  ],
  keyFormulas: [
    {
      latex: '\\sum_{i=1}^n i = n(n+1)/2',
      desc: {
        english: '',
        hindi: 'i=1 n i = n(n+1)/2',
      },
    },
    {
      latex: '\\sum_{i=1}^n i^2 = n(n+1)(2n+1)/6',
      desc: {
        english: '',
        hindi: 'i=1 n i 2 = n(n+1)(2n+1)/6',
      },
    },
    {
      latex: '\\sum_{i=1}^n i^3 = [n(n+1)/2]^2',
      desc: {
        english: '',
        hindi: 'i=1 n i 3 = [n(n+1)/2] 2',
      },
    },
    {
      latex: '2^n > n,\\ n \\ge 1',
      desc: {
        english: '',
        hindi: '2 एन > एन,\\ एन 1',
      },
    },
    {
      latex: 'n! > 2^n,\\ n \\ge 4',
      desc: {
        english: '',
        hindi: 'एन! > 2 एन,\\ एन 4',
      },
    },
    {
      latex: '\\sum_{i=1}^n (2i-1) = n^2',
      desc: {
        english: '',
        hindi: 'i=1 n (2i-1) = n 2',
      },
    },
    {
      latex: '\\sum_{i=0}^n r^i = (r^{n+1} - 1)/(r-1)',
      desc: {
        english: 'GP',
        hindi: 'जीपी',
      },
    },
  ],
  pyqs: [
    {
      year: 2023,
      exam: 'JEE Main',
      tag: 'Divisibility',
      problem: {
        english: 'Show $7^n - 3^n$ is divisible by 4.',
        hindi: 'दिखाएँ $7^n - 3^n$ 4 से विभाज्य है।',
      },
      answer: {
        english: 'Use induction: $7^{k+1} - 3^{k+1} = 7(7^k - 3^k) + 4\\cdot 3^k$.',
        hindi: 'प्रेरण का उपयोग करें: $7^{k+1} - 3^{k+1} = 7(7^k - 3^k) + 4\\cdot 3^k$।',
      },
      solution: {
        english: 'First term div by 4 (by hypothesis); second by 4 trivially.',
        hindi: 'पहला पद 4 से विभाजित (परिकल्पना द्वारा); 4 से दूसरा तुच्छ।',
      },
    },
    {
      year: 2022,
      exam: 'JEE Main',
      tag: 'Sum',
      problem: {
        english: 'Prove $1\\cdot2 + 2\\cdot3 + \\cdots + n(n+1) = n(n+1)(n+2)/3$.',
        hindi: '$1\\cdot2 + 2\\cdot3 + \\cdots + n(n+1) = n(n+1)(n+2)/3$ सिद्ध करें।',
      },
      answer: {
        english: 'Standard induction; add $(k+1)(k+2)$.',
        hindi: 'मानक प्रेरण; $(k+1)(k+2)$ जोड़ें।',
      },
      solution: {
        english: 'RHS$_k$ + $(k+1)(k+2)$ = $(k+1)(k+2)(k+3)/3$.',
        hindi: 'RHS$_k$ + $(k+1)(k+2)$ = $(k+1)(k+2)(k+3)/3$.',
      },
    },
    {
      year: 2021,
      exam: 'JEE Main',
      tag: 'Inequality',
      problem: {
        english: 'Prove $(1+x)^n \\ge 1+nx$ for $x > -1, n \\in \\mathbb{N}$ (Bernoulli).',
        hindi: '$x > -1, n \\in \\mathbb{N}$ (बर्नौली) के लिए $(1+x)^n \\ge 1+nx$ सिद्ध करें।',
      },
      answer: {
        english: 'Induction.',
        hindi: 'प्रेरण।',
      },
      solution: {
        english: '$(1+x)^{k+1} = (1+x)(1+x)^k \\ge (1+x)(1+kx) = 1 + (k+1)x + kx^2 \\ge 1 + (k+1)x$.',
        hindi: '$(1+x)^{k+1} = (1+x)(1+x)^k \\ge (1+x)(1+kx) = 1 + (k+1)x + kx^2 \\ge 1 + (k+1)x$.',
      },
    },
    {
      year: 2020,
      exam: 'JEE Main',
      tag: 'Divisibility',
      problem: {
        english: 'Show $4^n + 15n - 1$ is divisible by 9.',
        hindi: 'दिखाएँ $4^n + 15n - 1$ 9 से विभाज्य है।',
      },
      answer: {
        english: 'Induction.',
        hindi: 'प्रेरण।',
      },
      solution: {
        english: '$4^{k+1} + 15(k+1) - 1 = 4(4^k + 15k - 1) - 45k + 18 = 4P(k) + 9(-5k+2)$. Both terms div by 9.',
        hindi: '$4^{k+1} + 15(k+1) - 1 = 4(4^k + 15k - 1) - 45k + 18 = 4P(k) + 9(-5k+2)$. दोनों पद 9 से विभाजित हैं।',
      },
    },
    {
      year: 2019,
      exam: 'JEE Main',
      tag: 'Recurrence',
      problem: {
        english: 'If $a_1 = 1,\\ a_{n+1} = 3a_n + 1$, prove $a_n = (3^n - 1)/2$ by induction.',
        hindi: 'यदि $a_1 = 1,\\\\ a_{n+1} = 3a_n + 1$ है, तो प्रेरण द्वारा $a_n = (3^n - 1)/2$ सिद्ध करें।',
      },
      answer: {
        english: '',
        hindi: 'आवश्यक परिणाम: $a_n = (3^n - 1)/2$.',
      },
      solution: {
        english: 'Base ✓. Step: $a_{k+1} = 3 \\cdot (3^k - 1)/2 + 1 = (3^{k+1} - 3 + 2)/2 = (3^{k+1} - 1)/2$. ✓',
        hindi: 'आधार ✓. चरण: $a_{k+1} = 3 \\cdot (3^k - 1)/2 + 1 = (3^{k+1} - 3 + 2)/2 = (3^{k+1} - 1)/2$. ✓',
      },
    },
  ],
  next: {
    slug: 'linear-programming',
    title: 'Linear Programming',
  },
};

export default chapter;
